import './santabarb1/style';
import FormStructure from './santabarb1/form_structure';

export default FormStructure;